<template>
  <div class="pk-flex pk-videoview">
    <div v-if="showLoading"
     style="margin:50px 50px; z-index: 100; position:absolute;">
      <img src="../assets/icons/loading.gif"
       style="height:20px">
      <span v-if="inputData"> {{''}} (loading video... please wait a moment)</span>
    </div>
    <div
     class="pk-flex__1 pk-videoview-body pk-flex"
     style="position:relative; width:100%; height:100%">
      <video id="pk-video-window" v-if="inputData" controls class="pk-videoview-video" preload="metadata" buffered played ref="videoTag">
        <source 
         :src="inputData.src"
         :type="inputData.type">
        I'm sorry; your browser doesn't support HTML5 video with type {{ inputData.type}}.
      </video>
    </div>
  </div>
</template>

<script>
import { PKConfig } from '../config';
const pkConfig = require('../config.json');

export default {
  props: {
    inputData: {
      type: Object
    }
  },
  data() {
    return {
      startLoad: {
        done: false,
        threads: []
      },
      showLoading: false
    };
  },
  mounted() {
    const id = this.containerId;
    // console.log(id);
  },
  destroyed() {
    for (const subscriber of this.startLoad.threads) {
      subscriber.unsubscribe();
    }
  },
  watch: {
    inputData() {
      this.$refs.videoTag.load();
    }
  },
  computed: {
    containerId() {
      return this.$getRandomId();
    }
  },
  methods: {
    
  }
};
</script>

<style>
  .pk-videoview {
    height: 100%;
    background-color: #ddd;
  }
  
  .pk-videoview-body img {
    max-height: 100%;
    max-width: 100%;
    position: absolute;
  }
  
  .pk-videoview-video {
    margin: 0 auto;
    object-fit: scale-down;
    max-width: 100%;
  }

  .pk-videoview-side {
    width: auto;
    align-items: flex-end;
  }
  
  .pk-videoview-side img {
    width: 35px;
    height: 35px;
    cursor: pointer;
  }
  
  .pk-videoview-side img:hover {
    background-color: #fff;
  }
  
  #overlays-div {
    border: 1px solid red;
  }
</style>